import { useEffect as c } from "react";
const d = (n, t, s = []) => {
  c(() => {
    const o = (u) => {
      const e = u.target;
      t.current && !t.current.contains(e) && !(e != null && e.closest("#popup-root")) && n();
    };
    return document.addEventListener("mousedown", o), () => document.removeEventListener("mousedown", o);
  }, [t, ...s]);
};
export {
  d as default
};
